// GENERATED by scripts/import-pacing.mjs from src/rules/progression/pacing/*.csv.
// Don't edit: change the sheet, export the CSVs, run `npm run import-pacing`.
const PACING = {
    "arenas": {
        "1": {
            "maxStructures": 2,
            "hiveLevelToAscendInto": 1,
            "levelCap": 3,
            "killsToWin": 1,
            "expectedWars": 4,
            "cumulativeWarsToReach": 0,
            "botStructureLevel": 1,
            "botLotCount": 3
        },
        "2": {
            "maxStructures": 2,
            "hiveLevelToAscendInto": 2,
            "levelCap": 4,
            "killsToWin": 1,
            "expectedWars": 5,
            "cumulativeWarsToReach": 4,
            "botStructureLevel": 2,
            "botLotCount": 5
        },
        "3": {
            "maxStructures": 3,
            "hiveLevelToAscendInto": 4,
            "levelCap": 5,
            "killsToWin": 1,
            "expectedWars": 7,
            "cumulativeWarsToReach": 9,
            "botStructureLevel": 2,
            "botLotCount": 8
        },
        "4": {
            "maxStructures": 3,
            "hiveLevelToAscendInto": 7,
            "levelCap": 6,
            "killsToWin": 1,
            "expectedWars": 10,
            "cumulativeWarsToReach": 16,
            "botStructureLevel": 3,
            "botLotCount": 12
        },
        "5": {
            "maxStructures": 4,
            "hiveLevelToAscendInto": 14,
            "levelCap": 7,
            "killsToWin": 2,
            "expectedWars": 15,
            "cumulativeWarsToReach": 26,
            "botStructureLevel": 4,
            "botLotCount": 18
        },
        "6": {
            "maxStructures": 4,
            "hiveLevelToAscendInto": 18,
            "levelCap": 8,
            "killsToWin": 2,
            "expectedWars": 18,
            "cumulativeWarsToReach": 41,
            "botStructureLevel": 5,
            "botLotCount": 26
        }
    },
    "levels": {
        "2": {
            "rawCost": 1000,
            "refinedUnits": 0,
            "rounds": 3,
            "gemPriceFromZero": 3,
            "bucksCost": 200
        },
        "3": {
            "rawCost": 1500,
            "refinedUnits": 0,
            "rounds": 10,
            "gemPriceFromZero": 10,
            "bucksCost": 300
        },
        "4": {
            "rawCost": 2300,
            "refinedUnits": 0,
            "rounds": 18,
            "gemPriceFromZero": 18,
            "bucksCost": 400
        },
        "5": {
            "rawCost": 3500,
            "refinedUnits": 0,
            "rounds": 25,
            "gemPriceFromZero": 25,
            "bucksCost": 600
        },
        "6": {
            "rawCost": 5300,
            "refinedUnits": 2,
            "rounds": 33,
            "gemPriceFromZero": 33,
            "bucksCost": 800
        },
        "7": {
            "rawCost": 8000,
            "refinedUnits": 3,
            "rounds": 40,
            "gemPriceFromZero": 40,
            "bucksCost": 1100
        },
        "8": {
            "rawCost": 12000,
            "refinedUnits": 5,
            "rounds": 48,
            "gemPriceFromZero": 48,
            "bucksCost": 1500
        }
    },
    "structures": {
        "Lumber Mill": {
            "family": "Economy",
            "unlockArena": 1,
            "recipe": {
                "timber": 80,
                "metal": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "timber",
            "duplicatePayout": {
                "timber": 80,
                "metal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for timber lots"
        },
        "Vault": {
            "family": "Chest",
            "unlockArena": 1,
            "recipe": {
                "timber": 100,
                "metal": 100
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": null,
            "duplicatePayout": {
                "timber": 100,
                "metal": 100
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Mine": {
            "family": "Economy",
            "unlockArena": 2,
            "recipe": {
                "metal": 80,
                "coal": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "metal",
            "duplicatePayout": {
                "metal": 80,
                "coal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for metal lots"
        },
        "Warehouse": {
            "family": "Chest",
            "unlockArena": 3,
            "recipe": {
                "timber": 100,
                "coal": 80
            },
            "costTier": 1,
            "refinedInput": "Steel",
            "extractorFor": null,
            "duplicatePayout": {
                "timber": 100,
                "coal": 80
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Colliery": {
            "family": "Economy",
            "unlockArena": 3,
            "recipe": {
                "coal": 80,
                "metal": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "coal",
            "duplicatePayout": {
                "coal": 80,
                "metal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for coal lots"
        },
        "Watchtower": {
            "family": "Intel",
            "unlockArena": 4,
            "recipe": {
                "timber": 60,
                "silicon": 60
            },
            "costTier": 0.6,
            "refinedInput": null,
            "extractorFor": null,
            "duplicatePayout": {
                "timber": 60,
                "silicon": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Well": {
            "family": "Economy",
            "unlockArena": 4,
            "recipe": {
                "water": 80,
                "timber": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "water",
            "duplicatePayout": {
                "water": 80,
                "timber": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for water lots"
        },
        "Smelter": {
            "family": "Economy",
            "unlockArena": 4,
            "recipe": {
                "metal": 120,
                "coal": 100
            },
            "costTier": 1.5,
            "refinedInput": null,
            "extractorFor": null,
            "duplicatePayout": {
                "metal": 120,
                "coal": 100
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": "Steel",
            "notes": "Converter: metal + coal -> Steel"
        },
        "Rocket Pad": {
            "family": "Defense",
            "unlockArena": 5,
            "recipe": {
                "metal": 100,
                "oil": 80
            },
            "costTier": 1,
            "refinedInput": "Steel",
            "extractorFor": null,
            "duplicatePayout": {
                "metal": 100,
                "oil": 80
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Jammer": {
            "family": "Intel",
            "unlockArena": 5,
            "recipe": {
                "silicon": 60,
                "coal": 40
            },
            "costTier": 0.6,
            "refinedInput": null,
            "extractorFor": null,
            "duplicatePayout": {
                "silicon": 60,
                "coal": 40
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Depot": {
            "family": "Network",
            "unlockArena": 5,
            "recipe": {
                "oil": 140,
                "metal": 100
            },
            "costTier": 1.5,
            "refinedInput": "Steel",
            "extractorFor": null,
            "duplicatePayout": {
                "oil": 140,
                "metal": 100
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Effect TBD in the structure design stage (old effect depended on roads, which were removed)"
        },
        "Derrick": {
            "family": "Economy",
            "unlockArena": 5,
            "recipe": {
                "oil": 80,
                "metal": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "oil",
            "duplicatePayout": {
                "oil": 80,
                "metal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for oil lots"
        },
        "Bunker": {
            "family": "Defense",
            "unlockArena": 6,
            "recipe": {
                "limestone": 140,
                "metal": 60
            },
            "costTier": 1,
            "refinedInput": "Concrete",
            "extractorFor": null,
            "duplicatePayout": {
                "limestone": 140,
                "metal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Foundry": {
            "family": "Economy",
            "unlockArena": 6,
            "recipe": {
                "coal": 140,
                "metal": 100
            },
            "costTier": 1.5,
            "refinedInput": "Steel",
            "extractorFor": null,
            "duplicatePayout": {
                "coal": 140,
                "metal": 100
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": ""
        },
        "Silicon Pit": {
            "family": "Economy",
            "unlockArena": 6,
            "recipe": {
                "silicon": 80,
                "metal": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "silicon",
            "duplicatePayout": {
                "silicon": 80,
                "metal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for silicon lots"
        },
        "Sand Pit": {
            "family": "Economy",
            "unlockArena": 6,
            "recipe": {
                "sand": 80,
                "metal": 60
            },
            "costTier": 1,
            "refinedInput": null,
            "extractorFor": "sand",
            "duplicatePayout": {
                "sand": 80,
                "metal": 60
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": null,
            "notes": "Extractor for sand lots"
        },
        "Cement Works": {
            "family": "Economy",
            "unlockArena": 6,
            "recipe": {
                "limestone": 120,
                "sand": 100
            },
            "costTier": 1.5,
            "refinedInput": null,
            "extractorFor": null,
            "duplicatePayout": {
                "limestone": 120,
                "sand": 100
            },
            "stopsLotProduction": false,
            "shape": [
                [
                    0,
                    0
                ]
            ],
            "converterOutput": "Concrete",
            "notes": "Converter: limestone + sand -> Concrete"
        }
    },
    "lotTypes": {
        "timber": {
            "extractor": "Lumber Mill",
            "firstArena": 1
        },
        "metal": {
            "extractor": "Mine",
            "firstArena": 2
        },
        "coal": {
            "extractor": "Colliery",
            "firstArena": 3
        },
        "water": {
            "extractor": "Well",
            "firstArena": 4
        },
        "oil": {
            "extractor": "Derrick",
            "firstArena": 5
        },
        "silicon": {
            "extractor": "Silicon Pit",
            "firstArena": 6
        },
        "sand": {
            "extractor": "Sand Pit",
            "firstArena": 6
        }
    },
    "chests": {
        "1": {
            "raw": {
                "timber": 24,
                "metal": 215,
                "coal": 0,
                "water": 0,
                "oil": 0,
                "silicon": 0,
                "sand": 0,
                "limestone": 0
            },
            "lotCards": 1,
            "gems": 10
        },
        "2": {
            "raw": {
                "timber": 180,
                "metal": 558,
                "coal": 258,
                "water": 0,
                "oil": 0,
                "silicon": 0,
                "sand": 0,
                "limestone": 0
            },
            "lotCards": 1,
            "gems": 10
        },
        "3": {
            "raw": {
                "timber": 1141,
                "metal": 1467,
                "coal": 1397,
                "water": 0,
                "oil": 0,
                "silicon": 0,
                "sand": 0,
                "limestone": 0
            },
            "lotCards": 1,
            "gems": 10
        },
        "4": {
            "raw": {
                "timber": 1995,
                "metal": 3670,
                "coal": 3193,
                "water": 927,
                "oil": 0,
                "silicon": 528,
                "sand": 0,
                "limestone": 0
            },
            "lotCards": 1,
            "gems": 10
        },
        "5": {
            "raw": {
                "timber": 2798,
                "metal": 4810,
                "coal": 3747,
                "water": 844,
                "oil": 3103,
                "silicon": 1170,
                "sand": 0,
                "limestone": 0
            },
            "lotCards": 1,
            "gems": 10
        },
        "6": {
            "raw": {
                "timber": 3916,
                "metal": 5997,
                "coal": 5457,
                "water": 1083,
                "oil": 3715,
                "silicon": 2649,
                "sand": 3153,
                "limestone": 3989
            },
            "lotCards": 1,
            "gems": 10
        }
    },
    "genesisChest": {
        "structures": [
            "Lumber Mill"
        ],
        "lots": {
            "timber": 3
        }
    },
    "inputs": {
        "yieldPerLotPerRound": 1,
        "extractorYieldMultiplier": 3,
        "survivalRewardBucksPerLevel": 100,
        "loserSurvivalRewardShare": 0.5,
        "warChestsPerWin": 1,
        "gemPricePerRoundRemaining": 1,
        "maxStructuresHardCap": 9,
        "hiveCells": 315,
        "asyncTurnDeadlineHours": 24,
        "asyncMissesToForfeit": 2,
        "converterRefinedOutputPerWar": 3,
        "converterRawInputPerRefinedUnit": 100,
        "yieldToRawRate": 0.5,
        "lotOverflowRaw": 100,
        "unownedBuildWeight": 3,
        "syncClockSeconds": 420,
        "inviteExpiryHours": 24,
        "convertersEnabled": false,
        "rocketCostYield": 200,
        "reconCostYield": 100,
        "syncRevealAllowanceSeconds": 60
    }
}

export default PACING
